import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useSetRecoilState } from "recoil";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { filterDisplayState } from "../../recoil/filterAtoms";

interface DockedFilterSectionProps {
  children: React.ReactNode;
}

export default function DockedFilterSection({ children }: DockedFilterSectionProps) {
  const setFilterDisplay = useSetRecoilState(filterDisplayState);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        borderTop: "0.5px solid var(--dk-border, rgba(0,0,0,0.08))",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: "12px",
          height: "34px",
          flexShrink: 0,
          bgcolor: "var(--dk-surface-2, #f5f5f5)",
          borderBottom: "0.5px solid var(--dk-border, rgba(0,0,0,0.08))",
        }}
      >
        <Typography
          sx={{
            flex: 1,
            fontSize: "11px",
            fontWeight: 500,
            color: "#777",
            letterSpacing: "0.02em",
          }}
        >
          이미지 필터
        </Typography>

        <Tooltip title="모달로 열기" placement="left" arrow>
          <IconButton
            size="small"
            onClick={() => setFilterDisplay("float")}
            sx={{
              width: 22,
              height: 22,
              color: "var(--dk-text-3, #aaa)",
              "&:hover": { color: "var(--dk-text-2, #555)", bgcolor: "rgba(0,0,0,0.05)" },
            }}
          >
            <OpenInNewIcon sx={{ fontSize: 13 }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ flex: 1, overflow: "hidden" }}>{children}</Box>
    </Box>
  );
}
